/**
 * Cierre de sesión centralizado. Limpia todos los datos de la sesión.
 */
import { AppDispatch } from '../store/store';
import { clearAuth } from '../store/slices/authSlice';
import { clearSessionData, supabase } from '../lib/supabase';
import { clearAdminUsersCache } from '../pages/AdminUsers';
import { clearSystemParametersCache } from '../pages/SystemParameters';

export async function performLogout(
  dispatch: AppDispatch,
  navigate: (path: string) => void
): Promise<void> {
  try {
    // 1. Limpiar datos de sesión (localStorage, sessionStorage, caches)
    await clearSessionData();

    // 2. Limpiar caches de módulos admin
    clearAdminUsersCache();
    clearSystemParametersCache();

    // 3. Limpiar Redux
    dispatch(clearAuth());

    // 4. Cerrar sesión en Supabase
    await supabase().auth.signOut();

    // 5. Navegar al login
    navigate('/login');
  } catch (error) {
    console.error('Error al cerrar sesión:', error);
    // Aún así navegar al login en caso de error
    navigate('/login');
  }
}
